import { MANAGEABLE_USERS } from '@/store/actions/maxplus.actions';

const initialState = {
  manageable_users: []
};

export default function other(state = initialState, action) {
  switch (action.type) {
    case MANAGEABLE_USERS:
      return {
        ...state,
        manageable_users: action.payload.data
      };
    default:
      return state;
  }
}
